module.exports = __webpack_public_path__ + "static/media/banner-kalendarium.df9a2974.png";